import React, { useState, useEffect, useRef } from "react";
import logoHead from "../../images/Logo_head_white.png";
import BlogCard from "./BlogCard";
import { articles } from "./BlogArticles";
import styles from "./BlogPost.module.css";
import Footer from "../Footer";

const colors = {
  mainBlue: "#061941",
  gold: "#F2AF29",
  isabelline: "#F4F3EE",
};

export default function Blog() {
  const [visibleCards, setVisibleCards] = useState([]);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardId = parseInt(entry.target.dataset.cardId);
            setVisibleCards(prev => 
              prev.includes(cardId) ? prev : [...prev, cardId]
            );
          }
        });
      },
      { threshold: 0.1, rootMargin: "100px" }
    );

    cardRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  // Preload first few cards immediately
  useEffect(() => {
    const initialCards = articles.slice(0, 3).map(article => article.id);
    setVisibleCards(initialCards);
  }, []);

  return (
    <div className={styles.blogPage} style={{ fontFamily: "Segoe UI, Arial, sans-serif" }}>
      <header className={styles.blogHeader}>
        <img src={logoHead} alt="NeuHawk logo" className={styles.blogLogo} />
        <h1 className={styles.blogTitle}>NeuHawk Blog</h1>
      </header>
      <main className={styles.blogMain}>
        <div className={styles.blogCardsContainer}>
          {articles.map((article, index) => (
            <div
              key={article.id}
              ref={el => cardRefs.current[index] = el}
              data-card-id={article.id}
              className={styles.blogCardWrapper}
              style={{
                opacity: visibleCards.includes(article.id) ? 1 : 0,
                transform: visibleCards.includes(article.id) 
                  ? "translateY(0) scale(1)" 
                  : "translateY(40px) scale(0.95)",
                transition: `all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
                transitionDelay: `${Math.min(index * 0.15, 1.2)}s`,
                willChange: "opacity, transform"
              }}
            >
              <BlogCard 
                article={article} 
                isVisible={visibleCards.includes(article.id)}
                index={index}
              />
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
